import React, { useEffect, useState } from "react";
import { Autocomplete, Box, Button, IconButton, Tooltip, Typography } from "@mui/material"; 
import { FormControl, TextField } from "@mui/material";
import { CardHeader } from "reactstrap";
import { useAuth } from "oidc-react"; 
import { useNavigate } from "react-router-dom";
import moment from "moment"; 
import { Icon } from "@progress/kendo-react-common"; 
import { getUserId, getUserRole } from "../../../_helper/helper";
import PrintIcon from "@mui/icons-material/Print";


const PayrollHeaderVerification = (props) => {
  const {
    allPayPeriod,
    setPayPeriod,
    payPeriod,
    openModalPrint,
    setOpenModalPrint
  } = props;
  const { userData } = useAuth();
  let role = getUserRole(userData);
  const userId = getUserId(userData);
  const history = useNavigate(); 
  
  const sortedPayPeriod =
    allPayPeriod?.length > 0 &&
    allPayPeriod?.sort((a, b) => {
      return b.ID - a.ID;
    });

  const currentPayPeriodIndex =
    sortedPayPeriod?.length > 0 &&
    sortedPayPeriod?.findIndex((i) => i?.ID === payPeriod?.ID);
  const handleChangePayPeriod = (skipType) => {
    if (skipType === "next") {
      if (currentPayPeriodIndex > 0) {
        setPayPeriod(allPayPeriod[currentPayPeriodIndex - 1]);
      }
    } else {
      if (currentPayPeriodIndex < allPayPeriod.length - 1) {
        setPayPeriod(allPayPeriod[currentPayPeriodIndex + 1]);
      }
    }
  }; 

  return (
    <>
      {" "}
      <CardHeader>
        <div>
          <div
            className={`flex flex-1 w-full bg-primary page-content`}
            style={{
              display: "flex",
              flexDirection: "row",
              height: "4.2rem",
              borderRadius: "5px",
              alignItems: "center",
            }}
          >
            <Icon name="arrow-left" style={{ cursor: "pointer", fontSize: "35px" }} onClick={() => history(
              `/dashboard/default`)} />

             
            <Icon style={{ fontSize: '25px' }} className="m-r-10" name="file-ascx" />
            <Typography className="fs-5">
              {role === "user" ? "Payroll Work Time" : ""}
              <b className="pl-2"> Pay Period </b>
            </Typography>

            <div style={{ display: "flex", flex: 1 ,justifyContent:"space-between"}} className="mx-4">
              <div>
              <FormControl className="payperiodRange">
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <div style={{ cursor: "pointer", padding: "15px" }}>
                    {currentPayPeriodIndex < sortedPayPeriod.length - 1 && (
                      <Icon style={{ fontSize: '25px' }} name="arrow-chevron-left" onClick={() => handleChangePayPeriod("prev")} />

                    )}
                  </div>
                  {sortedPayPeriod?.length > 0 && (
                    <Autocomplete
                      size="small"
                      name="payperiod_range"
                      id="payperiod_range"
                      className="min-w-128 text-16"
                      disableClearable={true}
                      style={{ color: "red" }}
                      value={{
                        ID: payPeriod?.ID,
                        StartDate: moment(payPeriod?.StartDate).format(
                          "MM-DD-YYYY"
                        ),
                        EndDate: moment(payPeriod?.EndDate).format(
                          "MM-DD-YYYY"
                        ),
                      }}
                      isOptionEqualToValue={(option, value) =>
                        option.id === value.id
                      }
                      onChange={(event, value) => {

                        let info = allPayPeriod.find((i) => {
                          return i.ID.toString() === value?.ID.toString() + "";
                        }); 
                        if (info) {
                          // lockPayPeriod(info)
                          setPayPeriod(info); 
                        }
                      }}
                      options={sortedPayPeriod}
                      getOptionLabel={(option) =>
                        `${moment(option.StartDate).format(
                          "MM-DD-YYYY"
                        )} TO ${moment(option.EndDate).format("MM-DD-YYYY")}`
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          margin="dense"
                          variant="outlined"
                          style={{ minWidth: "300px" }}
                          inputProps={{
                            ...params.inputProps,
                            style: { color: "white" },
                          }}
                        />
                      )}
                    />
                  )}
                  <div style={{ cursor: "pointer", padding: "15px" }}>
                    {currentPayPeriodIndex > 0 && (
                      <Icon style={{ fontSize: '25px' }} name="arrow-chevron-right" onClick={() => handleChangePayPeriod("next")} /> 
                    )}
                  </div>
                  
                </div>
              </FormControl>
              </div>
              <div style={{marginTop:"8px"}}>
              <IconButton
                onClick={() => {
                  setOpenModalPrint(!openModalPrint);
                }}
              >
                <PrintIcon style={{color:"white"}} />
              </IconButton>
              </div>
            </div> 
          </div>
        </div> 
      </CardHeader > {" "} 
    
    </>
  );
};

export default PayrollHeaderVerification;
